export function lightenColor(hex: string, opacity = 0.5, lightFactor = 1.0) {
  // Remove the hash if it exists
  hex = hex.replace(/^#/, "");

  // Handle 3-character hex colors
  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((char) => char + char)
      .join("");
  }

  // Parse the hexadecimal color to get Red, Green, Blue components
  let r = parseInt(hex.slice(0, 2), 16);
  let g = parseInt(hex.slice(2, 4), 16);
  let b = parseInt(hex.slice(4, 6), 16);

  // Increase each component by a factor-adjusted amount and ensure they do not exceed 255
  r = Math.min(255, r + Math.floor(64 * lightFactor));
  g = Math.min(255, g + Math.floor(66 * lightFactor));
  b = Math.min(255, b + Math.floor(68 * lightFactor));

  // Convert each component back to a two-digit hexadecimal number
  const hexR = r.toString(16).padStart(2, "0");
  const hexG = g.toString(16).padStart(2, "0");
  const hexB = b.toString(16).padStart(2, "0");

  // Return the color with the specified opacity
  return `#${hexR}${hexG}${hexB}${Math.floor(opacity * 255)
    .toString(16)
    .padStart(2, "0")}`;
}
